import { useUnit } from 'effector-react'
import {
  $participants,
  $totalCountOfParticipants,
  getParticipantsFx,
} from './model'

export const useParticipantsList = () => {
  const participants = useUnit($participants)
  const totalCountOfParticipants = useUnit($totalCountOfParticipants)
  const loading = useUnit(getParticipantsFx.pending)

  return {
    participants,
    totalCountOfParticipants,
    loading,
  }
}
